import { useEffect } from 'react'

import { useAnalyticsConfig } from '@/shared/api/analyticsConfigQueries'
import {
  isAnalyticsAllowed,
  isMarketingAllowed,
  useCookieConsent,
} from '@/shared/hooks/useCookieConsent'
import { analyticsRuntime } from '@/shared/lib/analytics'
import { syncSentryAnalyticsConsent } from '@/shared/lib/sentryConsent'

/**
 * Syncs consent → data-analytics + analytics providers (admin-configured) + Sentry traces.
 */
export function AnalyticsConsentSync() {
  const consent = useCookieConsent()
  const config = useAnalyticsConfig()
  const analytics = isAnalyticsAllowed(consent)
  const marketing = isMarketingAllowed(consent)

  useEffect(() => {
    document.documentElement.dataset.analytics = analytics ? '1' : '0'
    syncSentryAnalyticsConsent(analytics)
  }, [analytics])

  useEffect(() => {
    if (config.data === undefined) {
      return
    }
    analyticsRuntime.sync(config.data, { analytics, marketing })
  }, [config.data, analytics, marketing])

  return null
}
